import { useState } from "react";
import { statusLabel, fmtDate, STATUS_COLOR } from "./constants";
import { DetailModal, InteractionForm, InteractionsList } from "./DetailShared";

export function OfferDetail({ id, data, onClose, onOpenCandidate }) {
  const [tab, setTab] = useState("details");
  const o = data.offer;
  return (
    <DetailModal testid="offer-detail" title={o.title} subtitle={`${o.company} · ${[o.city, o.country].filter(Boolean).join(", ")}`}
      onClose={onClose} activeTab={tab} setActiveTab={setTab}
      tabs={[["details", "Détails"], ["candidatures", `Candidatures (${data.counters.applications_count})`],
             ["interactions", `Historique (${data.interactions.length})`]]}>
      {tab === "details" && (
        <div data-testid="offer-tab-details" className="space-y-4">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              ["Candidatures", data.counters.applications_count], ["Candidats uniques", data.counters.candidates_distinct],
              ["Présélectionnés", data.counters.preselected], ["Entretiens", data.counters.interviews],
              ["Retenus", data.counters.retained], ["Postes", o.positions || "—"],
              ["Salaire", o.salary ? `${o.salary} ${o.salary_currency || "CAD"}` : "—"], ["Statut", o.status],
            ].map(([k, v]) => (
              <div key={k} className="bg-slate-50 rounded-lg p-3 text-center">
                <p className="text-lg font-bold text-brand-navy">{v}</p><p className="text-xs text-slate-500">{k}</p>
              </div>
            ))}
          </div>
          <div className="text-sm space-y-2">
            <p className="text-xs font-semibold text-slate-500 uppercase">Description</p>
            <p className="text-slate-700 whitespace-pre-line">{o.description || "—"}</p>
            <div className="flex flex-wrap gap-1.5 pt-1">
              {(o.skills || []).map((s) => <span key={s} className="text-xs bg-brand-sky text-brand-navy rounded-full px-2.5 py-0.5">{s}</span>)}
            </div>
            <p className="text-xs text-slate-400">
              Type : {o.employment_type || "—"} · Expérience : {o.experience || "—"} · Créée le {fmtDate(o.created_at)}
            </p>
          </div>
        </div>
      )}
      {tab === "candidatures" && (
        <div data-testid="offer-tab-candidatures" className="space-y-2 max-h-80 overflow-y-auto">
          {data.applications.length === 0 && <p className="text-sm text-slate-400 text-center py-6">Aucune candidature sur cette offre.</p>}
          {data.applications.map((a) => (
            <button key={a.application_id} data-testid={`offer-application-${a.application_id}`} onClick={() => onOpenCandidate(a.candidate_id)}
              className="w-full text-left border border-slate-100 rounded-lg px-4 py-3 hover:border-brand-turquoise transition-colors flex items-center justify-between gap-3">
              <div>
                <p className="font-medium text-brand-navy text-sm">{a.candidate_name}</p>
                <p className="text-xs text-slate-500">{a.candidate_email} · {fmtDate(a.created_at)}</p>
              </div>
              <span className={`text-xs font-medium rounded-full px-2.5 py-1 ${STATUS_COLOR(a.status)}`}>{statusLabel(a.status, "candidate")}</span>
            </button>
          ))}
        </div>
      )}
      {tab === "interactions" && (
        <div data-testid="offer-tab-interactions">
          <InteractionForm testid="offer" entityType="offer" entityId={id} onAdded={onClose} />
          <InteractionsList testid="offer" interactions={data.interactions} />
        </div>
      )}
    </DetailModal>
  );
}
